import React, { Fragment, useRef } from "react"
import { Dialog, Transition } from "@headlessui/react"

const Modal = ({ size, isOpen, title, subtitle, onClose, children }) => {
  // let refDiv = useRef(null)

  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          // initialFocus={refDiv}
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={onClose}
        >
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

          {/* ref={refDiv} */}
          <div className="min-h-screen text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              {/* <div className="inline-block w-full overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg"> */}
              <div
                className={
                  size === "full"
                    ? "inline-block w-full min-h-screen max-h-screen  text-left align-middle transition-all transform bg-white shadow-xl rounded-lg"
                    : `inline-block w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 my-8 align-middle `
                }
              >
                <div className=" text-left transition-all transform bg-white shadow-xl rounded-lg">
                  <header className="p-6 border-b-2 border-gray-100">
                    <Dialog.Title className="text-xl leading-none font-medium text-gray-900">
                      {title}
                    </Dialog.Title>

                    {subtitle && (
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">{subtitle}</p>
                      </div>
                    )}
                  </header>

                  <div className="p-6">{children}</div>
                </div>
              </div>
            </Transition.Child>
          </div>

          <button
            type="button"
            className="opacity-0 absolute bottom-0"
          ></button>
        </Dialog>
      </Transition>
    </>
  )
}

export default Modal
